import * as con from './constants';
import { AnyAction } from 'redux';
import type { DocsListQuery } from '../../openapi/operations/docsList';
import type { UsersListQuery } from '../../openapi/operations/usersList';
import type { OrdersListQuery } from '../../openapi/operations/ordersList';
import type { EpsiOrdersListQuery } from '../../openapi/operations/epsiOrdersList';
import type { PublishsetsListQuery } from '../../openapi/operations/publishsetsList';
import type { SubjektyListQuery } from '../../openapi/operations/subjektyList';
import type { GeodesistsListQuery } from '../../openapi/operations/geodesistsList';
import type { OrganizationsListQuery } from '../../openapi/operations/organizationsList';
import type { R7UrceniEditoraZpsListQuery } from '../../openapi/operations/r7UrceniEditoraZpsList';
import type { PriceListItemsListQuery } from '../../openapi/operations/priceListItemsList';
import type { ServiceOrdersListQuery } from '../../openapi/operations/serviceOrdersList';

const filterState = {
  docList: {} as DocsListQuery,
  checkList: {} as DocsListQuery,
  userList: {} as UsersListQuery,
  orderList: {} as OrdersListQuery,
  epsiOrderList: {} as EpsiOrdersListQuery,
  publishsetList: {} as PublishsetsListQuery,
  subjectList: {} as SubjektyListQuery,
  organizationList: {} as OrganizationsListQuery,
  geodesistsList: {} as GeodesistsListQuery,
  svuList: {} as R7UrceniEditoraZpsListQuery,
  priceListItemList: {} as PriceListItemsListQuery,
  serviceOrderList: {} as ServiceOrdersListQuery,
};

export const filter = (state = filterState, action: AnyAction): typeof filterState => {
  switch (action.type) {
    case con.DOC_LIST_FILTER_SET: {
      const newState = {
        ...state,
        ...{
          docList: action.payload,
        },
      };
      window.localStorage.setItem('filter', JSON.stringify(newState));
      return newState;
    }
    case con.CHECK_LIST_FILTER_SET: {
      const newState = {
        ...state,
        ...{
          checkList: action.payload,
        },
      };
      window.localStorage.setItem('filter', JSON.stringify(newState));
      return newState;
    }
    case con.USER_LIST_FILTER_SET: {
      const newState = {
        ...state,
        ...{
          userList: action.payload,
        },
      };
      window.localStorage.setItem('filter', JSON.stringify(newState));
      return newState;
    }
    case con.ORDER_LIST_FILTER_SET: {
      const newState = {
        ...state,
        ...{
          orderList: action.payload,
        },
      };
      window.localStorage.setItem('filter', JSON.stringify(newState));
      return newState;
    }
    case con.EPSI_ORDER_LIST_FILTER_SET: {
      const newState = {
        ...state,
        ...{
          epsiOrderList: action.payload,
        },
      };
      window.localStorage.setItem('filter', JSON.stringify(newState));
      return newState;
    }
    case con.PUBLISHSET_LIST_FILTER_SET: {
      const newState = {
        ...state,
        ...{
          publishsetList: action.payload,
        },
      };
      window.localStorage.setItem('filter', JSON.stringify(newState));
      return newState;
    }
    case con.SUBJECT_LIST_FILTER_SET: {
      const newState = {
        ...state,
        ...{
          subjectList: action.payload,
        },
      };
      window.localStorage.setItem('filter', JSON.stringify(newState));
      return newState;
    }
    case con.GEODESISTS_LIST_FILTER_SET: {
      const newState = {
        ...state,
        ...{
          geodesistsList: action.payload,
        },
      };
      window.localStorage.setItem('filter', JSON.stringify(newState));
      return newState;
    }
    case con.ORGANIZATION_LIST_FILTER_SET: {
      const newState = {
        ...state,
        ...{
          organizationList: action.payload,
        },
      };
      window.localStorage.setItem('filter', JSON.stringify(newState));
      return newState;
    }
    case con.SVU_LIST_FILTER_SET: {
      const newState = {
        ...state,
        ...{
          svuList: action.payload,
        },
      };
      window.localStorage.setItem('filter', JSON.stringify(newState));
      return newState;
    }
    case con.PRICE_LIST_ITEM_LIST_FILTER_SET: {
      const newState = {
        ...state,
        ...{
          priceListItemList: action.payload,
        },
      };
      window.localStorage.setItem('filter', JSON.stringify(newState));
      return newState;
    }
    case con.SERVICE_ORDER_LIST_FILTER_SET: {
      const newState = {
        ...state,
        ...{
          serviceOrderList: action.payload,
        },
      };
      window.localStorage.setItem('filter', JSON.stringify(newState));
      return newState;
    }
    default: {
      window.localStorage.setItem('filter', JSON.stringify(state));
      return state;
    }
  }
};
